//
//
//
//
//
//

import { startCase } from 'lodash-es';
import titleCase from '@/utils/title-case';
export default {
  props: {
    dark: { type: Boolean, default: false },
    absolute: { type: Boolean, default: false },
  },
  computed: {
    breadcrumbs() {
      // trim leading and trailing slash from pathname and split into segments array
      const segments = this.$route.path.replace(/^\/+|\/+$/g, '').split('/');
      const breadcrumbs = [{ text: 'Home', to: '/' }];

      segments.forEach((segment, index) => {
        const text = titleCase(startCase(segment));
        const to = this.localePath(
          '/' + segments.slice(0, index + 1).join('/'),
        );
        breadcrumbs.push({ text, to, exact: true });
      });

      return breadcrumbs;
    },
  },
};
